import { render, staticRenderFns } from "./review-form.vue?vue&type=template&id=6a0bef22&"
import script from "./review-form.vue?vue&type=script&lang=js&"
export * from "./review-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports